/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_PrintInputs */

const en_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print receipt`)
};

const de_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung drucken`)
};

const fr_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimer le reçu`)
};

const es_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir justificante`)
};

const it_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stampa ricevuta`)
};

const nl_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontvangstbewijs afdrukken`)
};

const pl_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drukuj potwierdzenie`)
};

const fi_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulosta kuitti`)
};

const da_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udskriv kvittering`)
};

const sv_consumer_declaration_print = /** @type {(inputs: Consumer_Declaration_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv ut kvitto`)
};

/**
* | output |
* | --- |
* | "Print receipt" |
*
* @param {Consumer_Declaration_PrintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_print = /** @type {((inputs?: Consumer_Declaration_PrintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_PrintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_print(inputs)
	if (locale === "fr") return fr_consumer_declaration_print(inputs)
	if (locale === "es") return es_consumer_declaration_print(inputs)
	if (locale === "it") return it_consumer_declaration_print(inputs)
	if (locale === "nl") return nl_consumer_declaration_print(inputs)
	if (locale === "pl") return pl_consumer_declaration_print(inputs)
	if (locale === "fi") return fi_consumer_declaration_print(inputs)
	if (locale === "da") return da_consumer_declaration_print(inputs)
	if (locale === "sv") return sv_consumer_declaration_print(inputs)
	return en_consumer_declaration_print(inputs)
});